import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import { usePromotePageData } from 'src/app/pages/promote/pageContext';

export type BanditTrackingProperties = {
	combo_bandit_variant: string | undefined;
	combo_bandit_value: number | undefined;
	promoted_bandit_variant_shown: string | undefined;
	promoted_bandit_variant_shown_value: readonly number[] | undefined;
	context: string | undefined; // Bandits R7 Experiment Context
	content: string | undefined; // Bandits R7 Experiment Content
};

export function useBanditTrackingProperties(): BanditTrackingProperties {
	const {
		data: {
			petition: { bandits },
			comboBanditData,
			amountChoices,
		},
	} = usePromotePageData();
	const { cookies } = useUtilityContext();

	return {
		combo_bandit_variant: comboBanditData?.variant.variantName,
		combo_bandit_value: comboBanditData?.variant.data.amount,
		promoted_bandit_variant_shown: bandits?.contextualPromotionButtons?.selectedVariant?.variantName,
		promoted_bandit_variant_shown_value: bandits?.contextualPromotionButtons?.selectedVariant?.data.amounts,
		context: cookies.get('psf_combo_bandit_r7'), // Bandits R7 Experiment Context
		content: cookies.get('psf_combo_bandit_r7') ? JSON.stringify(amountChoices) : undefined, // Bandits R7 Experiment Content
	};
}
